(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("configureLeaderboardSystem", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/gamification/configureLeaderboardSystemView.html",
            controller: ["gamificationResource", "messageService", "authService", "frameworkService", "$state", ConfigureLeaderboardSystemCtrl],
            controllerAs: "vm"
        };
        function ConfigureLeaderboardSystemCtrl(gamificationResource, messageService, authService, frameworkService, $state) {
            var vm = this;
            vm.saving = false;
            vm.loading = true;
            if (!frameworkService.data.tenantFeatures.gamificationLeaderboardSystem) {
                $state.go("main.notFound");
                return;
            }
            vm.currentUserName = authService.authentication.userFullName;
            vm.sample = [
                { rank: 1, name: "Sarah Boysen", tier: "Diamond", points: 100, tierIcon: "/images/gamification/Tier/Platinum.png" },
                { rank: 2, name: "Albert Einstein", tier: "Platinum", points: 80, tierIcon: "/images/gamification/Tier/Platinum.png" },
                { rank: 3, name: vm.currentUserName, profileImage: authService.authentication.pictureUrl, tier: "Platinum", points: 79, tierIcon: "/images/gamification/Tier/Platinum.png" },
                { rank: 4, name: "Jane Goodall", tier: "Gold", points: 50, tierIcon: "/images/gamification/Tier/Gold.png" }
            ];
            gamificationResource.getLeaderboardSystemViewModel(function (data) {
                vm.data = data;
                vm.loading = false;
            });
            vm.save = function () {
                vm.saving = true;
                gamificationResource.updateLeaderboardSystem({ settings: vm.data }, function () {
                    messageService.success("gamification.leaderboardSystem.saved");
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
        }
    });
})();
